import _difference from 'lodash-es/difference'

import { AccountTypeName, OfferAccountType } from '@igs-web/common-models/constants/account-type'
import { AccountStatus } from '@igs-web/common-models/models/account-model'
import { UserProfileAccount } from '@igs-web/common-models/models/user-profile-model'
import { nonUnique } from '@igs-web/common-utilities/utilities/array-utilities'

export const selectNonDuplicateAccounts = (accounts: ReadonlyArray<UserProfileAccount>): ReadonlyArray<UserProfileAccount> => {
    const lineOfBusinessCodes = accounts.map(account => account.lineOfBusinessCode)
    const duplicateLobs = nonUnique(lineOfBusinessCodes)
    const duplicateAccounts = accounts
        .filter(account => account.status === AccountStatus.inactive)
        .filter(account => duplicateLobs.includes(account.lineOfBusinessCode))

    return _difference(accounts, duplicateAccounts)
}

export const mapAccountTypeNameToOfferAccountType = (accountTypeName?: string | null): OfferAccountType => {
    return accountTypeName === AccountTypeName.Commercial ? OfferAccountType.Commercial : OfferAccountType.Residential
}

export const getAccountTypeName = (accountType: string | OfferAccountType | AccountTypeName): AccountTypeName => {
    switch (accountType) {
        case OfferAccountType.Commercial:
        case AccountTypeName.Commercial:
            return AccountTypeName.Commercial
        case OfferAccountType.Residential:
        case AccountTypeName.Residential:
            return AccountTypeName.Residential
        case AccountTypeName.ChoiceIndustrial:
            return AccountTypeName.ChoiceIndustrial
        default:
            throw Error('Account Type not supported')
    }
}

export const getOfferAccountType = (accountType: string | OfferAccountType | AccountTypeName): OfferAccountType => {
    switch (accountType) {
        case OfferAccountType.Commercial:
        case AccountTypeName.Commercial:
            return OfferAccountType.Commercial
        case OfferAccountType.Residential:
        case AccountTypeName.Residential:
            return OfferAccountType.Residential
        default:
            throw Error('Account Type not supported')
    }
}

